import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';
import { RpaBotType } from './rpa-bots-type.enum';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
import { IRPAAutomationAnywhereBot, IRPAAutomationAnywhereDevice, IRPAAutomationAnywherePoolDevice, IRPAAutomationAnywhereUser, IRpaConnection, IRpaConnectionAutomationAnywhere, IRpaConnectionBluePrism, IRpaConnectionUiPath } from './IRpaBots';

@Injectable()
export class RpaBotsService {
  private _rpaBots = 'api/bots';
  constructor(
    private _restApi: RestApi,
    private _toastService: BzgToastService,
    private _translateService: TranslateService,
    private _i18nService: I18nService
  ) { }

  getConnectionsAutomationAnywhere(): Observable<IRpaConnection[]> {
    return this._restApi.get(
      `${this._rpaBots}/${RpaBotType.AutomationAnywhere}`
    );
  }

  getConnectionsBluePrism(): Observable<IRpaConnection[]> {
    return this._restApi.get(`${this._rpaBots}/${RpaBotType.BluePrism}`);
  }

  getConnectionsUiPath(): Observable<IRpaConnection[]> {
    return this._restApi.get(`${this._rpaBots}/${RpaBotType.UiPath}`);
  }

  updateConnectionUiPath(
    rpa: IRpaConnectionUiPath
  ): Observable<IRpaConnectionUiPath> {
    return this._restApi.post(`${this._rpaBots}/UiPath`, rpa);
  }

  updateConnectionBluePrism(
    rpa: IRpaConnectionBluePrism
  ): Observable<IRpaConnectionBluePrism> {
    return this._restApi.post(`${this._rpaBots}/BluePrism`, rpa);
  }

  updateConnectionAutomationAnywhere(
    rpa: IRpaConnectionAutomationAnywhere
  ): Observable<IRpaConnectionAutomationAnywhere> {
    return this._restApi.post(`${this._rpaBots}/AutomationAnywhere`, rpa);
  }

  testConnectionUiPath(
    rpa: IRpaConnectionUiPath
  ): Observable<IRpaConnectionUiPath> {
    return this._restApi.post(`${this._rpaBots}/UiPath/test`, rpa);
  }

  testConnectionBluePrism(
    rpa: IRpaConnectionBluePrism
  ): Observable<IRpaConnectionBluePrism> {
    return this._restApi.post(`${this._rpaBots}/BluePrism/test`, rpa);
  }
  testConnectionAutomationAnywhere(
    rpa: IRpaConnectionAutomationAnywhere
  ): Observable<IRpaConnectionAutomationAnywhere> {
    return this._restApi.post(`${this._rpaBots}/AutomationAnywhere/test`, rpa);
  }

  getVersionAutomationAnywhere(rpa:IRpaConnectionAutomationAnywhere):Observable<string>{
    return this._restApi.post(`${this._rpaBots}/AutomationAnywhere/version`, rpa);
  }

  getConnectionAutomationAnywhere(
    id: string
  ): Observable<IRpaConnectionAutomationAnywhere> {
    return this._restApi.get(
      `${this._rpaBots}/${RpaBotType.AutomationAnywhere}/${id}`
    );
  }

  getDevicesAutomationAnywhere(rpa:IRpaConnectionAutomationAnywhere):Observable<IRPAAutomationAnywhereDevice[]>{
    return this._restApi.post(`${this._rpaBots}/AutomationAnywhere/devices`, rpa);
  }

  getPoolDevicesAutomationAnywhere(rpa:IRpaConnectionAutomationAnywhere):Observable<IRPAAutomationAnywherePoolDevice[]>{
    return this._restApi.post(`${this._rpaBots}/AutomationAnywhere/pooldevices`, rpa);
  }

  getUsersAutomationAnywhere(rpa:IRpaConnectionAutomationAnywhere):Observable<IRPAAutomationAnywhereUser[]>{
    return this._restApi.post(`${this._rpaBots}/AutomationAnywhere/users`, rpa);
  }

  getBotsAutomationAnywhere(rpa:IRpaConnectionAutomationAnywhere):Observable<IRPAAutomationAnywhereBot[]>{
    return this._restApi.post(`${this._rpaBots}/AutomationAnywhere/bots`, rpa);
  }

  getConnectionBluePrism(id: string): Observable<IRpaConnectionBluePrism> {
    return this._restApi.get(`${this._rpaBots}/${RpaBotType.BluePrism}/${id}`);
  }

  getConnectionUiPath(id: string): Observable<IRpaConnectionUiPath> {
    return this._restApi.get(`${this._rpaBots}/${RpaBotType.UiPath}/${id}`);
  }

  getKeys(): Observable<Record<string, boolean>> {
    return this._restApi.get(`${this._rpaBots}/keys`);
  }
}
